import React from 'react'
import { NumberFieldSeeker } from '@ui-seeker/core'
import { number, object } from 'yup'
import { useAppFormHandler } from '@hooks'


export default function DoorsSelector() {


	const validation = object({
		doors: number()
			.nullable()
			.min(0, 'Must provide a number between 0 and 5')
			.max(5, 'Must provide a number between 0 and 5'),
	})


	const {
		doors,
		onDoorsChange,
		error,
	} = useAppFormHandler('doors', validation)


	return <NumberFieldSeeker
		value={doors === null ? '' : doors}
		error={error}
		label="Doors"
		onChange={e => onDoorsChange(e.target.value === '' ? null : e.target.value)}
	/>
}